import { render, staticRenderFns } from "./OperatingSystem.vue?vue&type=template&id=465423ea"
import script from "./OperatingSystem.vue?vue&type=script&lang=ts"
export * from "./OperatingSystem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports